/**
 * Created by Vadym Yatsyuk on 28.01.18
 */
export * from './src/app/modules/ngx-img-fallback/index';